export default __webpack_public_path__ + "static/media/GRUPO_5_2026.ab91fabe.pdf";